import React, { useEffect, useState } from 'react'
import Alert from '../../components/Alert'
import Table from '../../components/Table'
import MainButton from '../../components/templates/MainButton'
import SimpleCard from '../../components/templates/SimpleCard'
import styles from './createTransaction.module.scss'
import { Delete, Edit, LongArrowLeft, Sync } from '../../assets/icons'
import { useDispatch, useSelector } from 'react-redux'
import LoadingDots from '../../components/Loadings/LoadingDots'
import { createTransactionAction } from '../../redux/actions/createTransactionAction'
import Modal, { ModalHead, ModalWrapper } from "../../components/Modal"

const Verification = () => {
  const { items, isLoading, } = useSelector(state => state.createTransaction);
  const [itemData, setitemData] = useState()
  const [showModal, setShowModal] = useState()
  const [deleteData, setDeleteData] = useState()
  const dispatch = useDispatch();

  const onContinue = () => {
    dispatch(createTransactionAction.setCompletedStep({
      completedStep: {
        completedTwo: true
      }
    }))
    dispatch(createTransactionAction.deleteItem(itemData))
    dispatch(createTransactionAction.changeStep(3))
  }

  const backStep = () => {
    dispatch(createTransactionAction.setCompletedStep({
      completedStep: {
        completedOne: false
      }
    }))
    dispatch(createTransactionAction.changeStep(1))
  }

  const deleteTransaction = (item) => {
    const filtered = itemData.filter((e)=> e.index !== item.index)
    const newItems = filtered.map((e, i)=>{
      return { ...e, index: i }
    })
    setitemData(newItems)
    setShowModal(false)
  }

  useEffect(() => {
    const newItems = items.map((e, i)=>{
      return { ...e, index: i }
    })
    setitemData(newItems)
  }, [items])
  

  return (
    <>
      <div className="mb-24">
        <h5 className="font-size-16 text-dark-gray font-500">Buat Transaksi via XLSX</h5>
      </div>
      <SimpleCard className={styles.verification}>
        {!isLoading ?
          <>
            <Alert color="success" className="mb-24">
              <span className="font-size-14"><span className="font-500">Pengisian data berhasil!</span> Silahkan klik tombol <span className="font-500">“Lanjut”</span> dibawah jika Anda sudah yakin dengan data yang Anda input.</span>
            </Alert>
            <Table
              className={styles.table}
              data={itemData}
              config={{
                columns: [
                  {
                    title: 'Bank', key: 'bank'
                  },
                  {
                    title: 'No Rekening', key: 'bankAccount'
                  },
                  {
                    title: 'Nama', key: 'fullName'
                  },
                  {
                    title: 'Nominal (Rp)', key: 'amount', render: v=> v.toLocaleString("id-ID", {style:"currency", currency:"IDR"})
                  },
                  {
                    title: 'Email', key: 'email', render: v => v ?? '-'
                  },
                  {
                    title: 'Berita', key: 'description'
                  },
                  {
                    title: 'Status', key: 'info'
                  },
                  {
                    title: '', name: 'action', render: (v, row) => {
                      return (
                        <div className={styles.action}>
                          {/* <div className={styles.sync}>
                            <Sync />
                          </div>
                          <div className={styles.edit}>
                            <Edit />
                          </div> */}
                          <div className={styles.delete} onClick={e=> {
                            setDeleteData(row)
                            setShowModal(true)
                          }}>
                            <Delete  /> 
                          </div>
                        </div>
                      )
                    }
                  }
                ],
                withIndex: true,
                total: itemData?.length,
                limit: 10,
                currentPage: 1,
                showRender: (from, to, total) => `${from}-${to} dari ${total} transaksi`
              }}
            />
            <div className={styles.footer}>
              <div className={styles.btn}>
                <MainButton className={styles.backBtn} color="outlined" onClick={backStep}>
                  <LongArrowLeft className="mr-8" />
                  <span>Kembali</span>
                </MainButton>
                <MainButton className={styles.mainButton} onClick={onContinue} disabled={itemData?.length < 1}>
                  <span>Lanjut</span>
                </MainButton>
              </div>

              {/* <MainButton className={styles.mainButton}>
              <Refresh />
              <span>Sesuaikan Semua Nama</span>
            </MainButton> */}
            </div>
          </> :
          <>
            <Alert color="primary" className="mb-24"><span className="font-size-14">Sistem Piro sedang melakukan pengecekan file XLSX. Proses ini akan membutuhkan waktu 2-5 menit.</span></Alert>
            <div className={styles.progressBar}>
              <LoadingDots />
            </div>
          </>
        }
         <Modal in={showModal} onClose={() => setShowModal(false)}>
            <ModalWrapper>
              <p className="font-500 mb-12">Konfirmasi Hapus</p>
              <p className="text-dark-gray font-size-12 mb-24">Apakah anda yakin untuk menghapus?</p>
              <div style={{ display: "flex",  gap: "10px"}}>
                <MainButton color='danger' className="w-100" onClick={() => deleteTransaction(deleteData)}>Yakin</MainButton>
                <MainButton className="w-100" onClick={e=> setShowModal(false)}>Tidak</MainButton>
              </div>
            </ModalWrapper>
          </Modal>
      </SimpleCard>
    </>
  )
}

export default Verification
